export default __webpack_public_path__ + "static/media/funding.14b05125.jpg";